/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Merge_Next_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Unable to merge with next event" |
*
* @param {Shortcut_Keys_Merge_Next_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_merge_next_failed_toast = /** @type {((inputs?: Shortcut_Keys_Merge_Next_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Merge_Next_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de fusionner avec l'evenement suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführung mit dem nächsten Ereignis nicht möglich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile unire con l'evento successivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось объединить с следующим событием.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede fusionar con el próximo evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法与下一个事件合并")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のイベントと統合できません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगले इवेंट के साथ मर्ज करने में असमर्थ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível mesclar com o próximo evento.")
	return /** @type {LocalizedString} */ ("Unable to merge with next event")
});